export default "__VITE_ASSET__BN_rDEpd__"